import styled from 'styled-components';
import { RESIZER_CLASS_NAME } from './consts';
import { s4, s8, colors } from '@ardoq/design-tokens';

export const HorizontalResizableSectionContainer = styled.div<{
  $hasHorizontalScroll?: boolean;
}>`
  flex: 1;
  height: 100%;
  box-sizing: border-box;
  ${({ $hasHorizontalScroll }) => $hasHorizontalScroll && 'overflow-x: auto;'}
`;

export const HorizontalContainer = styled.div<{ $horizontalScroll?: boolean }>`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`;

export const HorizontalResizer = styled(styled.div<{ $isActive?: boolean }>`
  margin: 0 -${s4};
  width: ${s8};
  z-index: 5;
  height: 100%;
  cursor: ew-resize;
  pointer-events: all;
  background-color: ${props =>
    props.$isActive ? colors.transparent10 : 'transparent'};
  &:hover {
    background-color: ${colors.transparent10};
  }
`).attrs({ className: RESIZER_CLASS_NAME })``;

export const VerticalResizableSectionContainer = styled.div`
  flex: 1;
  width: 100%;
  box-sizing: border-box;
`;

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const VerticalResizer = styled(styled.div<{ $isActive?: boolean }>`
  margin: -${s4} 0;
  height: ${s8};
  z-index: 1;
  width: 100%;
  cursor: ns-resize;
  pointer-events: all;
  background-color: ${props =>
    props.$isActive ? colors.transparent10 : 'transparent'};
  &:hover {
    background-color: ${colors.transparent10};
  }
`).attrs({ className: RESIZER_CLASS_NAME })``;
